// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowDown: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 40" enableBackground="new 0 0 24 40" xmlSpace="preserve">
<polygon points="21.7,25.45 13.63,33.52 13.63,0.25 10.37,0.25 10.37,33.52 2.3,25.45 0,27.75 12,39.75 24,27.75 "/>
</svg>;
};

export default React.memo(ArrowDown);
